import React from 'react';
import { FaHeart } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            {/* <h3 className="footer-logo">DN</h3> */}
            {/* <p>Building the future of AI, one developer at a time.</p> */}
          </div>

          <div className="footer-links">
            {/* <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#blog">Blog</a></li>
              </ul>
            </div> */}

            {/* <div className="footer-section">
              <h4>Resources</h4>
              <ul>
                <li>
                  <a href="https://weaviate.io/developers/weaviate" target="_blank" rel="noopener noreferrer">
                    Weaviate Docs
                  </a>
                </li>
                <li>
                  <a href="https://github.com/dee-at-weaviate" target="_blank" rel="noopener noreferrer">
                    GitHub Repos
                  </a>
                </li>
                <li>
                  <a href="https://weaviate.io/blog" target="_blank" rel="noopener noreferrer">
                    Blog Posts
                  </a>
                </li>
                <li><a href="#talks">Speaking</a></li>
              </ul>
            </div> */}

            {/* <div className="footer-section">
              <h4>Connect</h4>
              <div className="footer-social">
                <a 
                  href="https://github.com/dee-at-weaviate"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                >
                  <FaGithub />
                </a>
                <a 
                  href="https://www.linkedin.com/in/deeptinaidu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </a>
                <a 
                  href="https://twitter.com/yourhandle"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
              </div>
            </div> */}
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {currentYear} Deepti Naidu <FaHeart className="heart-icon" /> 
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

